import { Pipe, PipeTransform } from '@angular/core';
import { IFeeAdjustmentCondition } from '../models/credential/scenarioRequirementDefinition.model';

@Pipe({
  name: 'feeAdjustmentCondition',
  standalone: false
})
export class FeeAdjustmentConditionPipe implements PipeTransform {
  transform(value: IFeeAdjustmentCondition): string {
    if (value && value.days) {
      return `${value.days} days ${value.operator.toLocaleLowerCase()}`;
    }
    return null;
  }
}
